import { render, staticRenderFns } from "./Alliance.vue?vue&type=template&id=d0eee57e"
import script from "./Alliance.vue?vue&type=script&lang=js"
export * from "./Alliance.vue?vue&type=script&lang=js"
import style0 from "./Alliance.vue?vue&type=style&index=0&id=d0eee57e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports